import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TUserPaginationOption, TLiftedFormModel } from '@monorepo/ui';
import {
  TRESPONSE_LEARNING_CURVE_DETAILS,
  TREQUEST_LEARNING_CURVE_DETAILS,
  TREQUEST_DELETE_LEARNING_CURVES,
  TREQUEST_ADD_LEARNING_CURVE_DAY,
  TLearningCurveDTO,
} from '@monorepo/types';

import * as LearningCurveActions from './learning-curve.actions';
import * as LearningCurveSelectors from './learning-curve.selectors';
import { TAddEditRowType } from './learning-curve.models';

export const LEARNING_CURVE_ITEMS_PER_PAGE_LIST = [50, 100, 150, 200];

@Injectable({
  providedIn: 'root',
})
export class LearningCurveFacade {
  constructor(private store: Store<TPlani8State>) {}

  resetLearningCurveInfo() {
    this.fetchLearningCurveInfo({
      page_number: 1,
      page_size: LEARNING_CURVE_ITEMS_PER_PAGE_LIST[0],
      filters: [],
    });
  }

  fetchLearningCurveInfo(fetchLearningCurvePayload: TREQUEST_LEARNING_CURVE_DETAILS) {
    this.store.dispatch(new LearningCurveActions.GetLearningCurvesInfo(fetchLearningCurvePayload));
  }

  addEditLearningCurveRow(
    updatedLearningCurve: TLearningCurveDTO,
    fetchLearningCurvePayload: TREQUEST_LEARNING_CURVE_DETAILS,
    addEditType: TAddEditRowType,
  ) {
    this.store.dispatch(
      new LearningCurveActions.AddEditLearningCurve(updatedLearningCurve, fetchLearningCurvePayload, addEditType),
    );
  }

  deleteLearningCurves(
    learningCurvesIds: TREQUEST_DELETE_LEARNING_CURVES,
    fetchLearningCurvePayload: TREQUEST_LEARNING_CURVE_DETAILS,
  ) {
    this.store.dispatch(new LearningCurveActions.DeleteLearningCurves(learningCurvesIds, fetchLearningCurvePayload));
  }

  addLearningCurveDay(
    currDays: TREQUEST_ADD_LEARNING_CURVE_DAY,
    fetchLearningCurvePayload: TREQUEST_LEARNING_CURVE_DETAILS,
  ) {
    return this.store.dispatch(new LearningCurveActions.AddLearningCurvesDay(currDays, fetchLearningCurvePayload));
  }

  setUserPaginationOption(option: TUserPaginationOption) {
    return this.store.dispatch(new LearningCurveActions.SetUserPaginationOption(option));
  }

  getLearningCurveInfo() {
    return this.store.pipe(select(LearningCurveSelectors.GetLearningCurveInfo));
  }

  getUserPaginationOption() {
    return this.store.pipe(select(LearningCurveSelectors.GetUserPaginationOption));
  }
}

export type TGetLearningCurvesInfo = ReturnType<LearningCurveFacade['getLearningCurveInfo']>;
export type TGetUserPaginationOption = ReturnType<LearningCurveFacade['getUserPaginationOption']>;
